var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/ContainerExtension.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-hr.js";
import "@adornis/forms/x-input.js";
import { html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
import { repeat } from "lit/directives/repeat.js";
import { BaseContainer } from "../../db/extensions/BaseContainer.js";
import "../components/x-buildify-border-radius-picker.js";
import "../components/x-buildify-color-picker.js";
import "../components/x-buildify-permission-selection.js";
import "../components/x-buildify-spacing-picker.js";
import { __renderBase, getExtensionForData } from "../globals/methods.js";
import "./../x-buildify-dropzone.js";
import { ExtensionBoilerplate } from "./ContentExtensionBoilerplate.js";
var ContainerExtension = {
  class: BaseContainer,
  toolbar: { icon: "flex_wrap", text: { default: "Container" } },
  render(instance, { defaultValues, isSubelement, dropzoneBefore, dropzoneAfter }) {
    return html`
      <x-container-extension
        .content=${instance}
        .defaultValues=${defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></x-container-extension>
    `;
  },
  editor({ content, contentController, controllerBaseKeyPath }) {
    return html`
      <x-flex space="sm">
        <x-buildify-border-radius-picker
          clearable
          select
          ${contentController.field(...controllerBaseKeyPath, "borderRadius")}
        ></x-buildify-border-radius-picker>
        <x-buildify-color-picker
          clearable
          placeholder="Hintergrundfarbe"
          type="color"
          ${contentController.field(...controllerBaseKeyPath, "backgroundColor")}
        ></x-buildify-color-picker>
      </x-flex>
    `;
  }
};
var XContainerExtension = class extends ExtensionBoilerplate {
  willUpdate(_changedProperties) {
    super.willUpdate(_changedProperties);
    this._contentFilteredSorted = this._consumedContent.value?.filter((base) => base && base.parentID === this.content.value?._id).sort((a, b) => a.index - b.index);
  }
  _content(content) {
    if (this._contentFilteredSorted?.length === 0) {
      return html` <x-buildify-dropzone .index=${0} .parentID=${content._id}></x-buildify-dropzone> `;
    }
    const contents = repeat(
      this._contentFilteredSorted ?? [],
      (content2) => content2._id,
      (content2, index) => this.__item(content2, content2.index, index)
    );
    return contents;
  }
  __item(content, contentIndex, index) {
    const isLastItem = index === (this._contentFilteredSorted ?? []).length - 1;
    const extension = getExtensionForData(content, this._consumedExtensions.value ?? []);
    if (!extension)
      return nothing;
    return extension.render(content, {
      defaultValues: {},
      isSubelement: false,
      dropzoneBefore: true,
      dropzoneAfter: isLastItem
    });
  }
  renderChild({ extensions, content }) {
    return __renderBase(extensions, content);
  }
  __wrapper(content) {
    return content;
  }
  __editHover() {
    if (this.isSubContent)
      return nothing;
    return html`
      <x-flex
        edit-hover
        ${css({ height: "14px", width: "14px", zIndex: "11" })}
        horizontal
        center
        crossaxis-center
        @click=${(e) => this._editContent(e)}
      >
        <x-icon ${css({ fontSize: "12px", color: "#fff" })}> settings </x-icon>
      </x-flex>
      ${this._dragHandle()}
    `;
  }
  _marginRight() {
    const margin = this.getValue("margin") ?? "";
    return margin;
  }
  _marginLeft() {
    const margin = this.getValue("margin") ?? "";
    return margin;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          width: `calc(100% - ${this._marginLeft()} - ${this._marginRight()})`,
          boxSizing: "border-box",
          height: "unset",
          maxWidth: "100%",
          // custom styling
          display: this.defaultValue("display", { global: "block" }),
          borderRadius: this.getValue("borderRadius"),
          backgroundColor: this.getValue("backgroundColor"),
          // in edit mode, add this style
          ...this._consumedMode.value === "edit" && !this.isSubContent ? {
            border: "1px solid #333",
            padding: "10px"
          } : {}
        },
        "[edit-hover]": {
          width: "14px",
          background: "#333"
        }
      }
    ];
  }
};
XContainerExtension = __decorateClass([
  customElement("x-container-extension")
], XContainerExtension);
export {
  ContainerExtension,
  XContainerExtension
};
